import { Component, OnInit } from '@angular/core';
import { changeBodyAttribute, getLayoutConfig } from '../shared/helper/utils';
import { LayoutConfig } from '../shared/models/layout-config.model';
import { LayoutColor } from '../shared/config/layout.model';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
})
export class PublicLayoutComponent implements OnInit {
  layoutConfig!: LayoutConfig;
  layoutColor!: LayoutColor;
  today: Date = new Date();

  constructor() {}

  ngOnInit(): void {
    this.setLayoutConfig();
  }

  /**
   * Establecer configuración de layout
   */
  setLayoutConfig(): void {
    this.layoutConfig = getLayoutConfig();
    this.layoutColor = this.layoutConfig.layoutColor;
    changeBodyAttribute('data-layout-color', this.layoutColor);
  }
}
